import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/pt'
import { locale } from '@/helpers/locale'

dayjs.extend(utc)

export function formatDate(date: string, format = 'MMMM D, YYYY'): string {
  return dayjs.utc(date).locale(locale).format(format)
}
